import React from 'react';
import { Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import useIsKioskMode from '../util/useIsKioskMode';
import { exitKiosk } from '../util/kioskExit';

export default function KioskExitButton({ redirectUrl }) {
  const isKioskMode = useIsKioskMode();
  const { path } = useParams();

  if (!isKioskMode) return null;

  const handleClick = () => {
    exitKiosk(path, redirectUrl);
  };

  return (
    <Button variant="contained" color="primary" size="large" onClick={handleClick}>
      Schließen
    </Button>
  );
}
